// src/v3/ui/_common/components/ui/data-page.tsx

import type { ReactNode } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "./card";
import { ErrorState } from "./error-state";
import { Loading } from "./loading";

interface DataPageProps {
  title: string;
  actions?: ReactNode;
  isLoading?: boolean;
  error?: string | null;
  children: ReactNode;
}

export function DataPage({
  title,
  actions,
  isLoading = false,
  error = null,
  children,
}: DataPageProps) {
  return (
    <Card>
      <CardHeader>
        <div className="flex min-w-0 max-w-full flex-wrap items-center justify-between gap-3">
          <CardTitle>{title}</CardTitle>
          {actions && <div className="flex min-w-0 max-w-full flex-wrap items-center gap-2">{actions}</div>}
        </div>
      </CardHeader>
      <CardContent>
        {isLoading && <Loading />}
        {!isLoading && error !== null && <ErrorState message={error} />}
        {!isLoading && error === null && children}
      </CardContent>
    </Card>
  );
}
